import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MediaService } from '../../media.service';

@Component({
  standalone: false,
  selector: 'media-image',
  templateUrl: './template.html',
  styleUrl: './style.scss',
})
export class MediaImageComponent implements OnChanges {
  @Input()
  imageId: string;

  @Input()
  variant: string = 'thumbnail';

  src: string;

  constructor(private mediaService: MediaService) {}

  ngOnChanges(changes: SimpleChanges) {
    this.src = this.mediaService.buildImageUrl(this.imageId, this.variant);
  }
}
